/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TarfReason = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
},
    },
};